"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StoryPoint_1 = require("../Models/StoryPoint");
const StoryPointInfo_1 = require("../Models/StoryPointInfo");
class StoryPointSwitchedEvent {
    constructor(_oldStoryPointInfoImpl, _currStoryPointImpl, _workbookImpl) {
        this._oldStoryPointInfoImpl = _oldStoryPointInfoImpl;
        this._currStoryPointImpl = _currStoryPointImpl;
        this._workbookImpl = _workbookImpl;
    }
    get oldStoryPointInfo() {
        return new StoryPointInfo_1.StoryPointInfo(this._oldStoryPointInfoImpl, this._workbookImpl);
    }
    get newStoryPoint() {
        return new StoryPoint_1.StoryPoint(this._currStoryPointImpl, this._workbookImpl);
    }
}
exports.StoryPointSwitchedEvent = StoryPointSwitchedEvent;
//# sourceMappingURL=StoryPointSwitchedEvent.js.map